/**
 * My plugins
 */

import axios from './axios'

export default {
  install (Vue) {
    axios(Vue)
  }
}
